angular.module('impactx.smartform').directive('ixSmartFormEditor', function (SmartFormTemplateCache, SmartFormService) {
    return {
        restrict: 'E',
        scope: {
            config: "=",
            usageType: "="
        },
        controller: 'SmartFormEditorCtrl',
        controllerAs: 'smartFormEditorCtrl',
        templateUrl: 'shared/smartform/templates/smart-form-editor.tmpl.html',
        link: function (scope) {
            initializeNewForm();

            var configWatcher = scope.$watch('config', function (config) {
                if (config) {
                    var layout = impactX.isDefined(scope, "config.layout");
                    scope.layout = layout ? layout : {};
                    if(impactX.isDefined(scope, "config.identifier")) {
                        scope.identifier = scope.config.identifier;
                    }
                    scope.formEntries = impactX.isDefined(scope, 'config.entries');
                    scope.smartFormGridsterOptions = SmartFormTemplateCache.createSmartFormGridsterConfig(scope.layout);

                    SmartFormTemplateCache.removeForm(scope.identifier);
                    addSmartFormToCache(scope.identifier, scope.formEntries);

                    function addSmartFormToCache(smartFormIdentifier, entries) {
                        angular.forEach(entries, function (entry) {
                            entry.layout.readOnly = true;
                            entry.layout.editable = true;
                            SmartFormTemplateCache.insertComponent(smartFormIdentifier, entry);
                        });
                    }
                    scope.formEntries = SmartFormTemplateCache.getForm(scope.identifier);

                    configWatcher();
                }
            });

            function initializeTemplateComponents() {
                scope.templateComponents = SmartFormTemplateCache.getComponents();
                for (var key in scope.templateComponents) {
                    if (scope.templateComponents.hasOwnProperty(key)) {
                        scope.templateComponents[key].layout.readOnly = true;
                        scope.templateComponents[key].layout.editable = false;
                        scope.templateComponents[key].label = scope.trns[key];
                        scope.templateComponents[key].templateDescription = scope.trns[key + 'Description'];
                    }
                }
            }

            function initializeNewForm() {
                scope.identifier = scope.identifier ? scope.identifier : "newForm";
                SmartFormService.getTranslations().then(function (trns) {
                    scope.trns = trns;
                    initializeTemplateComponents();
                });
            }
        }
    }
});